import Row from '../Row';
import * as ids from '../../../layerIdStrings';
import { getDialectIdsByKey } from '../../../utils';

export default [
    {
        component: Row,
        props: {
            id: ids.CR_OBLASTI,
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: ids.CR_OBLASTI,
            name: 'Oblasti',
            initial: true,
            icon: false,
            inputName: 'dialects',
            inputType: 'radio',
            dialectIds: () => {
                let dialectIds = [];
                const dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);

                for (let i in dialects) {
                    const dialect = dialects[i];

                    if (dialect.level == 'oblast') {
                        dialectIds.push(dialect.id);
                    }
                }

                return dialectIds;
            },
        }
    },
    {
        component: Row,
        props: {
            id: ids.CR_JEMNEJSI,
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: ids.CR_JEMNEJSI,
            name: 'Podrobnější nářeční členění<br>(podskupiny, úseky, typy)',
            initial: false,
            icon: false,
            inputName: 'dialects',
            inputType: 'radio',
            dialectIds: () => {
                let dialectIds = getDialectIdsByKey(ids.CR_JEMNEJSI);
                const dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);

                if (dialectIds.length == 0) {
                    for (let i in dialects) {
                        const dialect = dialects[i];

                        if (dialect.has_boundary == "1" && dialect.level != "region") {
                            dialectIds.push(dialect.id);
                        }
                    }
                    //dialectIds = Object.keys(dialects);
                }

                return dialectIds;
            },
        }
    },
    {
        component: Row,
        props: {
            id: 'dialects_none',
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: 'dialects_none',
            name: 'Nezobrazovat',
            initial: false,
            icon: false,
            inputName: 'dialects',
            inputType: 'radio',
            dialectIds: () => [],
        }
    },
];
